import { useTranslation } from "react-i18next"

import UnitSelectors from "./UnitSelectors"

import "./unit.scss"

export default function Page() {
  const { t } = useTranslation()

  return (
    <div className="UnitCont">
      <h3>{t("units")}</h3>
      <UnitSelectors />
    </div>
  )
}
